/**
 * Ryan O'Dowd
 * 2022-05-06
 * © Copyright 2022 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  Platform,
} from 'react-native';

const TEXT_BASE_HEIGHT = 18;

const getStyles = ({fonts, globalScale, colors}) => {
  return {
    lessonTextWrapper: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      color: colors.white,
      fontSize: globalScale * TEXT_BASE_HEIGHT,
      paddingTop: globalScale * 8,
      paddingBottom: globalScale * 8,
    },
    wrongGuessText: {
      color: colors.alert,
    },
    correctAnswer: { // @TODO: make sure this can't run into question/options on smaller screens and larger text
      display: 'flex',
    },
    correctAnswerText: {
      display: Platform.OS === 'web' ? 'inline' : 'flex',
      color: colors.white,
      fontSize: globalScale * TEXT_BASE_HEIGHT,
    },
    correctedWrongGuess: {
      color: colors.accentLight,
      fontFamily: fonts.primaryBold,
    },
    providedTextWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'baseline',
      alignSelf: 'center',
      paddingTop: globalScale * 0,
      marginTop: globalScale * 0,
      marginRight: globalScale * 4, // @TODO: should be able to be zero
      marginBottom: globalScale * 4, // @TODO: should be able to be zero
      paddingBottom: 5, // @TODO: otherwise bottoms of some letters cut off on android
    },
    providedText: {
      display: 'flex',
      justifyContent: 'baseline',
      alignSelf: 'center',
      color: colors.accentLight,
      fontSize: globalScale * TEXT_BASE_HEIGHT,
      lineHeight: globalScale * TEXT_BASE_HEIGHT,
    },
    guessTextWrapper: {
      flex: 0,
      height: globalScale * TEXT_BASE_HEIGHT,
      maxHeight: globalScale * TEXT_BASE_HEIGHT,
      paddingTop: Platform.OS === 'web' ? 0 : 2.5, // @TODO: magic
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
      lineHeight: globalScale * TEXT_BASE_HEIGHT,
      marginTop: Platform.OS === 'web' ? -1.6 : 0,
      marginBottom: 0,
      marginLeft: 0,
      marginRight: 0,
    },
    hiddenText: {
      position: 'absolute',
      opacity: 0,
    },
    guessText: {
      fontSize: globalScale * TEXT_BASE_HEIGHT,
      lineHeight: globalScale * TEXT_BASE_HEIGHT,
      borderColor: colors.accentLight,
      borderBottomWidth: globalScale * 2,
      marginTop: 0,
      marginBottom: 0, // @TODO: globalScale * -8,
      marginLeft: 0,
      marginRight: 0,
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
    },
    guessTextWidths: (width) => {
      return {
        minWidth: width,
        width: width,
      };
    },
    completeWord: {
      color: colors.white,
    },
  };
};

export default getStyles;
